import { dispatch } from 'store'
import { ItemClickHandlerType } from '../types'
import { useTimelineRangeSelection } from './use-timeline-range-selection'
import { editorThunks } from 'store/features/editor/thunks'
import { getHandlerType } from '../utils'
import { IItemClickHandlerParams } from 'store/types/editor'

export const useItemClickHandler = () => {
  const { handleRangeSelection, hasAnchor } = useTimelineRangeSelection()

  const actions = {
    [ItemClickHandlerType.RANGE_SELECT]: (params: IItemClickHandlerParams) => {
      handleRangeSelection({ id: params.id, type: params.type })
    },
    [ItemClickHandlerType.MULTI_SELECT]: (params: IItemClickHandlerParams) => {
      if (params.isActive) {
        dispatch(editorThunks.removeActiveTimelineItems([params.id]))
      } else {
        dispatch(
          editorThunks.addActiveTimelineItems([
            { id: params.id, type: params.type }
          ])
        )
      }
    },
    [ItemClickHandlerType.DEFAULT]: (params: IItemClickHandlerParams) => {
      dispatch(
        editorThunks.selectSingleTimelineItem({
          id: params.id,
          type: params.type
        })
      )
    }
  }

  const handler = (params: IItemClickHandlerParams) => {
    const handlerType = getHandlerType(params.event, hasAnchor)

    actions[handlerType](params)
  }

  return handler
}
